import axios from "axios";

export const GET_CATALOG = "GET_CATALOG";
export const GET_USER_CATALOG = "GET_USER_CATALOG";
export const SET_LEARN_FORMATION = "SET_LEARN_FORMATION";

const API = `${process.env.REACT_APP_API_URL}/api/formations`;
const ROOT = `${process.env.REACT_APP_API_URL}/api`;

export const getCatalog = (params = {}) => async (dispatch) => {
  try {
    const res = await axios.get(API, { params, withCredentials: true });
    dispatch({ type: GET_CATALOG, payload: res.data });
  } catch (error) {
    console.error(error);
  }
};

// Catalogue/badges d'un AUTRE utilisateur (pour son profil)
export const getUserCatalog = (userId) => async (dispatch) => {
  try {
    const res = await axios.get(`${API}/users/${userId}/catalog`, { withCredentials: true });
    dispatch({ type: GET_USER_CATALOG, payload: res.data });
  } catch (error) {
    console.error(error);
  }
};

// Renvoie { formation, progress }
export const getLearnFormation = (id) => async (dispatch) => {
  const res = await axios.get(`${API}/${id}/learn`, { withCredentials: true });
  dispatch({ type: SET_LEARN_FORMATION, payload: res.data });
  return res.data;
};

export const enrollFormation = (id) => async () => {
  const data = (await axios({ method: "post", url: `${API}/${id}/enroll`, withCredentials: true })).data;
  invalidateLeaderboardCache();
  return data;
};

export const completeLesson = (lessonId) => async () => {
  const data = (await axios({ method: "post", url: `${ROOT}/lessons/${lessonId}/complete`, withCredentials: true })).data;
  invalidateLeaderboardCache();
  return data;
};

export const attemptQuiz = (quizId, answers) => async () => {
  const data = (
    await axios({ method: "post", url: `${ROOT}/quizzes/${quizId}/attempt`, withCredentials: true, data: { answers } })
  ).data;
  invalidateLeaderboardCache();
  return data;
};

// Cache court du leaderboard : Menu (monté sur chaque page) et Formations
// appellent la même fonction, on partage la requête en vol et le résultat
// pendant un TTL court pour éviter les appels réseau en double.
const LEADERBOARD_TTL_MS = 60 * 1000;
let leaderboardCache = null; // { at, data }
let leaderboardInflight = null;

const invalidateLeaderboardCache = () => {
  leaderboardCache = null;
  leaderboardInflight = null;
};

// Renvoie { podium, me } pour le classement / podium
export const getLeaderboard = () => async () => {
  if (leaderboardCache && Date.now() - leaderboardCache.at < LEADERBOARD_TTL_MS) {
    return leaderboardCache.data;
  }
  if (!leaderboardInflight) {
    leaderboardInflight = axios
      .get(`${API}/leaderboard`, { withCredentials: true })
      .then((res) => {
        leaderboardCache = { at: Date.now(), data: res.data };
        return res.data;
      })
      .finally(() => {
        leaderboardInflight = null;
      });
  }
  return leaderboardInflight;
};
